// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"248f22a5","551":"f96cfca0","563":"d00fee19"}[chunkId] + ".chunk.js";
};